import { RootState } from 'lib/centralStore';
import Persist, { StorageKind } from 'lib/persist';
import { TOKEN_BASE_NAME } from 'utility/constant';
import { initialState } from 'features/auth/types';
import { createSelector } from 'reselect';

const cookie = Persist(StorageKind.cookie);

const _self = ({ auth }: RootState) => auth ?? initialState;

export const selectUser = createSelector([_self], ({ user }) => user);

export const selectToken = createSelector([_self], ({ token }) => token);

export const selectSignOut = createSelector([_self], ({ signOut }) => signOut);

export const selectIsLogged = createSelector([_self], ({ isLogged }) => isLogged);

export const selectApiStatus = createSelector([_self], ({ apiStatus }) => apiStatus);

export const selectAccessToken = (state: RootState) =>
  selectToken(state)?.accessToken ?? cookie.getItem(TOKEN_BASE_NAME);

export const selectCacheTokens = createSelector([_self], ({ cacheTokens }) => cacheTokens);

export const selectSelectedCard = createSelector([_self], ({ selectedCard }) => selectedCard);

export const selectSendGeoComply = createSelector([selectUser], (user) => user?.invio_geocomply);

export const selectSelectedPaymentType = createSelector([_self], ({ selectedPaymentType }) => selectedPaymentType);